// FilterSelect — Presentational labeled <select> used by the filters panel.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// and the option-mapping (keyed by index) are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { filterLabelStyle, filterSelectStyle } from './styles';

export const FilterSelect = React.memo(function FilterSelect({ label, value, onChange, options }) {
  return (
    <div>
      <label style={filterLabelStyle}>{label}</label>
      <select value={value} onChange={onChange} style={filterSelectStyle}>
        {options.map((opt, i) => (
          <option key={i} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
});

export default FilterSelect;
